module.exports = __webpack_public_path__ + "img/banks.6e7dfa6f.jpg";